import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  exportTotalWashingCountByRangeDay,
  exportWashingCountByDay,
  exportWashingCountByRangeDay,
  getTotalWashingCountByRangeDay,
  getWashingCountByDay,
  getWashingCountByRangeDay,
} from '@/apis/washingCount'
import { apiHost } from '@/configs/api'
import useNotification from '@/hooks/useNotification'
import {
  ExportTotalWashingCountByRangeDayRequest,
  ExportWashingCountByDayRequest,
  ExportWashingCountByRangeDayRequest,
  GetTotalWashingCountByRangeDayRequest,
  GetTotalWashingCountByRangeDayResponse,
  GetWashingCountByDayRequest,
  GetWashingCountByDayResponse,
  GetWashingCountByRangeDayRequest,
  GetWashingCountByRangeDayResponse,
} from '@/types/apis/washingCount'

export const useWashingCountByDay = () => {
  const openNotification = useNotification()
  const { t } = useTranslation()
  const [responseWashingCount, setResponseWashingCount] = useState<GetWashingCountByDayResponse>()
  const [responseWashingCountLoading, setResponseWashingCountLoading] = useState(false)
  const [responseWashingCountByRangeDayLoading, setResponseWashingCountByRangeDayLoading] = useState(false)
  const [responseWashingCountByRangeDay, setResponseWashingCountByRangeDay] =
    useState<GetWashingCountByRangeDayResponse>()
  const [exportWashingCountLoading, setExportWashingCountLoading] = useState(false)
  const [exportWashingCountByDayLoading, setExportWashingCountByDayLoading] = useState(false)
  const [responseTotalWashingCountLoading, setResponseTotalWashingCountLoading] = useState(false)
  const [responseTotalWashingCount, setResponseTotalWashingCount] = useState<GetTotalWashingCountByRangeDayResponse>()
  const [exportWashingCountByRangeDayLoading, setExportWashingCountByRangeDayLoading] = useState(false)

  const get = useCallback(async (request: GetWashingCountByDayRequest) => {
    try {
      setResponseWashingCountLoading(true)
      const res = await getWashingCountByDay(request)
      setResponseWashingCount(res)
    } finally {
      setResponseWashingCountLoading(false)
    }
  }, [])

  const getWashingByRangeDay = useCallback(
    async (request: GetWashingCountByRangeDayRequest) => {
      try {
        setResponseWashingCountByRangeDayLoading(true)
        const res = await getWashingCountByRangeDay(request)
        setResponseWashingCountByRangeDay(res)
      } catch {
        openNotification({
          type: 'error',
          description: t('components.pages.washingCount.listReport.hooks.selectRangeDateFail'),
        })
      } finally {
        setResponseWashingCountByRangeDayLoading(false)
      }
    },
    [openNotification, t]
  )

  const getTotalWashingByRangeDay = useCallback(
    async (request: GetTotalWashingCountByRangeDayRequest) => {
      try {
        setResponseTotalWashingCountLoading(true)
        const res = await getTotalWashingCountByRangeDay(request)
        setResponseTotalWashingCount(res)
      } catch {
        openNotification({
          type: 'error',
          description: t('components.pages.clientDevice.listReport.hooks.selectRangeDateFail'),
        })
      } finally {
        setResponseTotalWashingCountLoading(false)
      }
    },
    [openNotification, t]
  )

  const exportExcel = async (request: ExportWashingCountByDayRequest) => {
    try {
      setExportWashingCountLoading(true)
      const result = await exportWashingCountByDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
    } finally {
      setExportWashingCountLoading(false)
    }
  }

  const exportExcelByRangeDay = async (request: ExportWashingCountByRangeDayRequest) => {
    try {
      setExportWashingCountByDayLoading(true)
      const result = await exportWashingCountByRangeDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
    } finally {
      setExportWashingCountByDayLoading(false)
    }
  }

  const exportExcelTotalWashingByRangeDay = async (request: ExportTotalWashingCountByRangeDayRequest) => {
    try {
      setExportWashingCountByRangeDayLoading(true)
      const result = await exportTotalWashingCountByRangeDay(request)
      window.open(`${apiHost}${result.url}`, '_blank')
    } catch (err) {
    } finally {
      setExportWashingCountByRangeDayLoading(false)
    }
  }

  return {
    getWashingCountByDay: get,
    getWashingCountByRangeDay: getWashingByRangeDay,
    getTotalWashingByRangeDay,
    exportExcelWashingCountByDay: exportExcel,
    exportExcelByRangeDay,
    exportExcelTotalWashingByRangeDay,
    responseWashingCount,
    responseWashingCountLoading,
    responseWashingCountByRangeDay,
    responseWashingCountByRangeDayLoading,
    exportWashingCountLoading,
    exportWashingCountByDayLoading,
    responseTotalWashingCount,
    responseTotalWashingCountLoading,
    exportWashingCountByRangeDayLoading,
  }
}
